// Базовые селекторы
const selectCompanyPromotionsState = (state) => state.companyPromotions;

// Селекторы для списка акций
export const selectPromotions = (state) => selectCompanyPromotionsState(state).promotions;
export const selectPromotionsLoading = (state) => selectCompanyPromotionsState(state).promotionsLoading;
export const selectPromotionsError = (state) => selectCompanyPromotionsState(state).promotionsError;

// Селекторы для текущей акции
export const selectCurrentPromotion = (state) => selectCompanyPromotionsState(state).currentPromotion;
export const selectPromotionLoading = (state) => selectCompanyPromotionsState(state).promotionLoading;
export const selectPromotionError = (state) => selectCompanyPromotionsState(state).promotionError;

// Селекторы для создания/обновления
export const selectCreateLoading = (state) => selectCompanyPromotionsState(state).createLoading;
export const selectCreateError = (state) => selectCompanyPromotionsState(state).createError;
export const selectUpdateLoading = (state) => selectCompanyPromotionsState(state).updateLoading;
export const selectUpdateError = (state) => selectCompanyPromotionsState(state).updateError;

// Селекторы для обновления статуса
export const selectStatusUpdateLoading = (state) => selectCompanyPromotionsState(state).statusUpdateLoading;

// Селекторы для городов
export const selectCities = (state) => selectCompanyPromotionsState(state).cities;
export const selectCitiesLoading = (state) => selectCompanyPromotionsState(state).citiesLoading;

// Селекторы для инициаторов
export const selectInitiators = (state) => selectCompanyPromotionsState(state).initiators;
export const selectInitiatorsLoading = (state) => selectCompanyPromotionsState(state).initiatorsLoading;

// Селекторы для кнопок
export const selectButtons = (state) => selectCompanyPromotionsState(state).buttons;
export const selectButtonsLoading = (state) => selectCompanyPromotionsState(state).buttonsLoading;

// Комбинированные селекторы
export const selectFormData = (state) => {
  const companyPromotions = selectCompanyPromotionsState(state);
  return {
    cities: companyPromotions.cities,
    initiators: companyPromotions.initiators,
    buttons: companyPromotions.buttons
  };
};

// Селектор для определения состояния загрузки формы
export const selectFormLoading = (state) => {
  const companyPromotions = selectCompanyPromotionsState(state);
  return companyPromotions.citiesLoading || 
         companyPromotions.initiatorsLoading || 
         companyPromotions.buttonsLoading;
};

// Селектор для филиалов из городов
export const selectFilials = (state) => {
  const cities = selectCities(state);
  return cities?.filials || [];
};

// Селектор для опций городов в селекте
export const selectCityOptions = (state) => {
  const filials = selectFilials(state);
  return [
    { value: 'all', label: 'Все города' },
    ...filials.map(filial => ({
      value: filial.filial_id,
      label: filial.city_name
    }))
  ];
};

// Селектор для опций инициаторов в селекте
export const selectInitiatorOptions = (state) => {
  const initiators = selectInitiators(state);
  if (!initiators?.initiators) return [];
  
  return initiators.initiators.map(initiator => ({
    value: initiator.id,
    label: `${initiator.name} ${initiator.surname}`
  }));
};

// Селектор для опций кнопок в селекте
export const selectButtonOptions = (state) => {
  const buttons = selectButtons(state);
  if (!buttons?.buttons) return [];
  
  return buttons.buttons.map(button => ({
    value: button.id,
    label: button.button_name
  }));
};